module.exports = __webpack_public_path__ + "img/marche_creve.fd24f18e.jpg";